import FormControl from '@mui/material/FormControl';
import React from 'react';
import { SearchableSelectOption } from '../interfaces/Interfaces';
import { Autocomplete, SxProps, TextField } from '@mui/material';

interface Props {
    title: string;
    options: Array<SearchableSelectOption>;
    dataHandler: (data: string | null) => void;
    previouslySelectedOption?: SearchableSelectOption;
    sx?: SxProps;
}
export const SearchableSelect = ({
    title,
    options,
    dataHandler,
    previouslySelectedOption,
    sx,
}: Props) => {
    const handleChange = (event: any, value: string | null) => {
        dataHandler(value);
    };

    const selectOptions = () => {
        return options.map((option) => option.label + ' (' + option.id + ')');
    };

    return (
        <FormControl fullWidth sx={sx}>
            <Autocomplete
                defaultValue={
                    previouslySelectedOption
                        ? previouslySelectedOption.label +
                          ' (' +
                          previouslySelectedOption.id +
                          ')'
                        : null
                }
                onChange={handleChange}
                // disablePortal
                id="searchable-select"
                options={selectOptions()}
                renderInput={(params) => {
                    return <TextField {...params} label={title} />;
                }}
            />
        </FormControl>
    );
};
